export default `
    <div id="#= data.id #_cid" class="#= data.containerClasses ||  ""# #=data.bsc||""# # if (data.cf) { # checkbox # } #  ">
        <div # if (!data.cf) { # class="checkbox" # } #>
            <div class="checkbox-wrapper uncheckable #= data.showBox ? "show-box" : "" #">
                <input id="#= data.id #" type="checkbox" class="checkbox-input bind-value #= data.bindClasses || data.classes || data.valueClasses || ""#" data-bind="checked: #= data.bindValue #" disabled="disabled"/>
                <span class="checkbox-container">
                    <span class="checkbox-check">
                    </span>
                </span>
                <span class="checkbox-label bind-label" # if (data.label) { # data-bind="text: #= data.title #" # } # data-label-for-id="#= data.id #">
                    #=data.hcLabel || data.hcLabelAbove || ""## if (data.cf && !data.hideSS) { #<span class="checkbox-cf" title="#= z.ll("CustomFieldLabelTitle", true) #">C</span>
                # } #
                </span>
            </div>
        </div>
    </div>
`;
